// Lib
import React from 'react';
import { get } from 'lodash/fp';

// Components
import DefaultErrorRenderer from '../../components/error/errorBoundary/DefaultErrorRenderer';

// Styles
import './CanvasErrorRenderer.scss';

const getErrorDetails = ({ element, error, currentBoardId }) =>
    `The canvas for board "${currentBoardId}" could not be rendered.

Timestamp: ${new Date().toISOString()}
Error: ${error && error.toString()}
Stack: ${get('stack', error)}`;

const CanvasErrorRenderer = (props) => (
    <DefaultErrorRenderer
        {...props}
        className="CanvasErrorRenderer"
        heading="Something went wrong on the canvas"
        furtherDetails={
            <ul>
                <li>What you were doing when the issue occurred</li>
                <li>If this error happens to all boards or just this board</li>
                <li>Any other details that you think will help</li>
                <li>Please also paste in the error below:</li>
            </ul>
        }
        getErrorDetails={getErrorDetails}
    />
);

export default CanvasErrorRenderer;
